// Third Party Imports
import React from 'react';
import {ButtonPrimary, Button} from '@homeaway/react-buttons';

// Relative Imports
import './ContinueButtonHolder.less';

export default class ContinueButtonHolder extends React.Component {
    constructor(props) {
        super(props);
    }

    renderContinueButton() {
        const {
            enableContinueButton,
            handleContinueButtonClick,
            continueButtonId,
            translations,
            data
        } = this.props;
        if (enableContinueButton) {
            if (data) {
                return <ButtonPrimary label={translations['ipmob.create_account.button.text_2']} type="submit" value="Submit" id={continueButtonId} onClick={event => handleContinueButtonClick(event, data)}/>
            }
            return <ButtonPrimary label={translations['ipmob.create_account.button.text_2']} type="submit" value="Submit" id={continueButtonId} onClick={handleContinueButtonClick}/>
        }
        return <ButtonPrimary label={translations['ipmob.create_account.button.text_2']} type="submit" value="Submit" id={continueButtonId} disabled/>
    }

    render() {
        const {
            translations,
            enableBackButton,
            handleBackButtonClick
        } = this.props;

        return (
            <div className="continue-button-holder">
                <div className="divider"/>
                <div className={enableBackButton ? 'buttons-holder' : 'button-holder'}>
                    {
                        (enableBackButton)
                            ? <Button label={translations['ipmob.button.text_1']} className="back-btn" onClick={handleBackButtonClick}/>
                            : null
                    }
                    <span className={enableBackButton ? 'continue-btn' : 'continue-button'}>
                        {this.renderContinueButton()}
                    </span>
                </div>
            </div>
        );
    }
}
